module.exports = __webpack_public_path__ + "resources/img/bg_tcc_equipment_m.a54255bb98fcc94511237e09afa1b3ec.png";